import { fromBaseRecord } from '../compile/from-base-context';

/** The SELECT supplies the highest scoped sibling value, including a nullable/lean zone. */
export function encounterCreateZone(raw: unknown, masterParent: string, locationId: string): number {
    if (!fromBaseRecord(raw) || raw.encounter_master_parent_id !== masterParent
        || raw.encounter_location_id !== locationId || !Array.isArray(raw.sibling_zones))
        throw new Error('Encounter zone inputs unavailable. Please retry.');
    const highest = raw.sibling_zones[0];
    const zone = highest ? Number(window.ftEncounterField({ encounters: highest }, 'encounter_zone_number') ?? 0) : 0;
    return zone + 1;
}
